import React from "react";
import { bool, node, string } from "prop-types";
import { useTranslation } from "@lib/i18n";
import { motion } from "framer-motion";

import ExpansionPanel from "./ExpansionPanel";
import SimpleButton from "./SimpleButton";

const MoreInformation = ({
  children,
  label,
  expansionMode,
  isHtmlStringContent = false,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <ExpansionPanel
      dataId={`delivery-more-informations-${label}-panel`}
      expansionMode={expansionMode}
      header={({ isOpen }) => (
        <SimpleButton className="text-sm mx-0 my-4 p-0">
          {isOpen ? t("general.lessInformation") : t("general.moreInformation")}
        </SimpleButton>
      )}
      content={() => (
        <motion.div
          className="overflow-y-clip"
          initial="closed"
          animate="open"
          exit="closed"
          variants={{
            open: {
              opacity: 1,
              height: "auto",
              display: "block",
            },
            closed: {
              opacity: 0,
              height: 0,
              transitionEnd: { display: "none" },
            },
          }}
        >
          {isHtmlStringContent ? (
            <div
              className="pt-4 text-sm"
              data-id={`more-information-${label}-div`}
              dangerouslySetInnerHTML={{ __html: children }}
            />
          ) : (
            <div
              className="pt-4 text-sm"
              data-id={`more-information-${label}-div`}
            >
              {children}
            </div>
          )}
        </motion.div>
      )}
      {...props}
    />
  );
};

MoreInformation.propTypes = {
  children: node.isRequired,
  expansionMode: string,
  label: string,
  isHtmlStringContent: bool,
};

export default MoreInformation;
